import {updataTaskReview, getScoreImg, getDetailFile, sellerWorkTop, updateTaskDetail, taskCancel,} from '@/api/task'
const state = {
}

const mutations = {
}

const actions = {
  taskcancel({ commit }, data) {
    return new Promise((resolve, reject) => {
      taskCancel(data).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  updatetaskdetail({ commit }, data) {
    return new Promise((resolve, reject) => {
      updateTaskDetail(data).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  sellerworktop({ commit }, params) {
    return new Promise((resolve, reject) => {
      sellerWorkTop(params).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  updatataskreview({ commit }, params) {
    return new Promise((resolve, reject) => {
      updataTaskReview(params).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getscoreimg({ commit }, params) {
    return new Promise((resolve, reject) => {
      getScoreImg(params).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getdetailfile({ commit }, params) {
    return new Promise((resolve, reject) => {
      getDetailFile(params).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
